import { constants } from '../constants';
export const notificationApiError = {
    NETWORK_ERROR: {
        key: 'NETWORK_ERROR',
        message: constants.api_error_network_error
    },
    TIMEOUT: {
        key: 'TIMEOUT',
        message: constants.api_error_timeout
    },
    CORS_ERROR: {
        key: 'CORS_ERROR',
        message: constants.api_error_cors_error
    },
    UNAUTHORIZED: {
        key: 'UNAUTHORIZED',
        message: constants.api_error_unauthorized
    },
    FORBIDDEN: {
        key: 'FORBIDDEN',
        message: constants.api_error_forbidden
    },
    NOT_FOUND: {
        key: 'NOT_FOUND',
        message: constants.api_error_not_found
    },
    BAD_REQUEST: {
        key: 'BAD_REQUEST',
        message: constants.api_error_bad_request
    },
    RATE_LIMITED: {
        key: 'RATE_LIMITED',
        message: constants.api_error_rate_limited
    },
    SERVER_ERROR: {
        key: 'SERVER_ERROR',
        message: constants.api_error_server_error
    },
    NAME_DUPLICATION: {
        key: 'NAME_DUPLICATION',
        message: constants.api_error_name_duplication
    },
    MANDATORY_FIELDS_MISSING: {
        key: 'MANDATORY_FIELDS_MISSING',
        message: constants.api_error_mandatory_fields_missing
    },
    SERVICE_UNAVAILABLE: {
        key: 'SERVICE_UNAVAILABLE',
        message: constants.api_error_service_unavailable
    }
};
